// extracted by mini-css-extract-plugin
export default {"main":"work-cost_main__mbdOt","header":"work-cost_header__En5mJ","table":"work-cost_table__6nJRz","th1":"work-cost_th1__NOSQO"};